<template>
  <li
    v-if="!hidden"
    tabindex="0"
    class="dropdown__item dropdown__item--user"
    :class="[name && email ? 'dropdown__item--user-nae' : '']"
    @click="optionClicked"
  >
    <p4a-checkbox
      v-if="multiple"
      :textHidden="true"
      :checked="selected"
      @change="optionClicked"
    />
    <div class="dropdown__item--user-image">
      <img :src="image" alt="Profile" />
    </div>
    <div v-if="name" class="dropdown__item--user-name">
      {{ name }}
    </div>
    <div v-if="email" class="dropdown__item--user-email">
      {{ email }}
    </div>
  </li>
</template>

<script>
import { includes } from 'lodash'
import DropdownOption from '../../mixins/DropdownOption'

export default {
  mixins: [
    DropdownOption
  ],

  props: {
    image: {
      type: String,
      default: null
    },

    multiple: {
      type: Boolean,
      default: false
    },

    name: {
      type: String,
      default: ''
    },

    email: {
      type: String,
      default: ''
    }
  },

  methods: {
    searchUpdated (searchValue) {
      const search = searchValue.toLowerCase()

      let testValue = typeof this.value === 'number' || typeof this.value === 'boolean' ? this.value.toString() : this.value
      testValue = typeof testValue === 'string' ? testValue.toLowerCase() : testValue

      const name = this.name.toLowerCase()
      const email = this.email.toLowerCase()

      const hidden = searchValue !== '' && !includes(testValue, search) && !includes(name, search) && !includes(email, search)

      if (this.hidden !== hidden) {
        this.hidden = hidden
        this.updateOption()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// node_modules/pro4all-ui/ui-kit/components/Dropdown/UserDropdownOption.vue